// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","name":"styles_name__2Yb5Y"};